
const Affiliation = () => {
    return (
        <div>
            <h1>Affiliation</h1>
        </div>
    )
}

export default Affiliation;